import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { certificateService } from '@/services/certificateService'

export function useCertificate(id: string) {
  return useQuery({
    queryKey: ['certificate', id],
    queryFn: () => certificateService.getCertificate(id),
    enabled: !!id,
  })
}

export function useVerifyCertificate(token: string) {
  return useQuery({
    queryKey: ['certificate', 'verify', token],
    queryFn: () => certificateService.verifyCertificate(token),
    enabled: !!token,
  })
}

export function useUserCertificates(userId: string) {
  return useQuery({
    queryKey: ['certificates', 'user', userId],
    queryFn: () => certificateService.getUserCertificates(userId),
    enabled: !!userId,
  })
}

export function useMyCertificates(userId: string) {
  return useQuery({
    queryKey: ['certificates', 'my', userId],
    queryFn: () => certificateService.getMyCertificates(userId),
    enabled: !!userId,
  })
}

export function useGenerateCertificate() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (enrollmentId: string) => certificateService.generateCertificate(enrollmentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['certificates'] })
    },
  })
}
